import React from 'react';

import SubscriptionControl from '../../controls/member-grid/SubscriptionControl';

const SubscriptionMember = ({entityType}) => {
  return <SubscriptionControl entityType={entityType} />;
};

export default SubscriptionMember;
